/**
 * @file {@link https://www.rfc-editor.org/rfc/rfc9110#section-12 RFC 9110 12 Content Negotiation}
 */

import {
  FieldName,
  FieldType,
  fieldNameValueFormat,
  listFieldFormat,
  stringFieldValueFormat,
} from "./fields";

/**
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-12.5.1 RFC 9110 12.5.1 Accept}
 */
export const AcceptField = new FieldType(
  new FieldName("Accept"),
  listFieldFormat(stringFieldValueFormat),
);

/**
 * Accept-Charset
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-12.5.2 RFC 9110 12.5.2 Accept-Charset}
 */
export const AcceptCharsetField = new FieldType(
  new FieldName("Accept-Charset"),
  listFieldFormat(stringFieldValueFormat),
);

/**
 * Accept-Encoding
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-12.5.3 RFC 9110 12.5.3 Accept-Encoding}
 */
export const AcceptEncodingField = new FieldType(
  new FieldName("Accept-Encoding"),
  listFieldFormat(stringFieldValueFormat),
);

/**
 * Accept-Language
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-12.5.4 RFC 9110 12.5.4 Accept-Language}
 */
export const AcceptLanguageField = new FieldType(
  new FieldName("Accept-Language"),
  listFieldFormat(stringFieldValueFormat),
);

/**
 * Vary
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-12.5.5 RFC 9110 12.5.5 Var}
 */
export const VaryField = new FieldType(
  new FieldName("Vary"),
  listFieldFormat(fieldNameValueFormat),
);
